import React from "react";
import SimpleBar from "simplebar-react";
import { Email } from "types";
import { InfiniteList } from "@/components/Common/InfiniteList";
import { NoResults } from "@/components/Common/NoResults";
import { EmailListItem } from "@/components/Email/EmailListItem";
import { Loader } from "@/components/Loader";
import { useInfiniteCollection } from "@/hooks/useInfiniteCollection";

interface EmailHistoryListProps {
    search: string;
    onSelectEmail: (email?: Email) => void;
    selectedEmail?: Email;
}

export const EmailList = ({ search, onSelectEmail, selectedEmail }: EmailHistoryListProps) => {
    const { data, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage } = useInfiniteCollection<Email>("emails", {
        search,
        limit: 50,
    });

    if (isLoading) {
        return <Loader size="tiny" className="p-2" text="Loading Emails" />;
    }

    if (data.length === 0) {
        onSelectEmail(undefined);
        return <NoResults>No emails found</NoResults>;
    }

    if (selectedEmail && !data.some((email) => email.id === selectedEmail.id)) {
        onSelectEmail(undefined);
    }

    return (
        <SimpleBar className="ui-email-list" style={{ maxHeight: "100%" }}>
            <InfiniteList isLoading={isFetchingNextPage} hasMore={hasNextPage} onLoadMore={fetchNextPage}>
                <div className="email-list divide-y divide-gray-light">
                    {data.map((email: Email) => (
                        <EmailListItem
                            key={email.id}
                            email={email}
                            isSelected={email.id === selectedEmail?.id}
                            onSelectEmail={onSelectEmail}
                        />
                    ))}
                </div>
            </InfiniteList>
        </SimpleBar>
    );
};
